import { connect } from 'react-redux';
import ResetButton from './ResetButton';
import {
  fetchProductsBySection,
  setAccessoryList,
  setCornerAccessoryList,
  setCornerPostAccessoryList,
  setCornerPostsList,
  setInputDataToSend,
  setNecessaryProductsQuantity,
  setPostsList,
} from '../../../../store/form/actions';

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => dispatch(setInputDataToSend(key, data)),

  fetchProductsBySection: (
    section,
    panelGroup,
    postGroup,
    accessoryGroup,
    color,
    type,
    height,
  ) => {
    dispatch(fetchProductsBySection(
      section,
      panelGroup,
      postGroup,
      accessoryGroup,
      color,
      type,
      height,
    ));
  },

  setPostsList: (data) => {
    dispatch(setPostsList(data));
  },

  setAccessoryList: (data) => {
    dispatch(setAccessoryList(data));
  },

  setCornerPostsList: (data) => {
    dispatch(setCornerPostsList(data));
  },

  setCornerAccessoryList: (data) => {
    dispatch(setCornerAccessoryList(data));
  },

  setCornerPostAccessoryList: (data) => {
    dispatch(setCornerPostAccessoryList(data));
  },

  setNecessaryProductsQuantity: (data) => {
    dispatch(setNecessaryProductsQuantity(data));
  },
});

export default connect(null, mapDispatchToProps)(ResetButton);
